import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';

import { FLink } from '@components';
import { useSelector } from 'react-redux';
import {
  BENEFICIOS,
  CALENDARIO_EMPRESTIMO,
  COMUNICACAO_PLANO,
  CONTATO_EMPRESTIMO,
  CONTRACHEQUE,
  CONTRATOS_ABSOLUTE_PATH,
  CONVERSAO_BENEFICIOS,
  EMISSAO_BOLETO_VOLUNTARIO,
  EMPRESTIMO_CONSCIENTE,
  EXTRADO_SALDO_CONTAS,
  EXTRATO_PARTICIPANTE,
  HOME,
  IMPOSTO_DE_RENDA,
  INFORME_RENDIMENTOS,
  INTENCAO_MUDANCA_PC_ABSOLUTE_PATH,
  INTENCAO_MUDANCA_PERFIL_ABSOLUTE_PATH,
  MEMORIA_CALCULO,
  MEUS_DADOS,
  MUDANCA_PC_ABSOLUTE_PATH,
  MUDANCA_PERFIL_ABSOLUTE_PATH,
  PARCELA_ADICIONAL,
  PERCENTUAL_RENDA_MENSAL_ABSOLUTE_PATH,
  PERSONALIZACAO,
  // PERCENTUAL_RENDA_MENSAL,
  QUESTIONARIO_ABSOLUTE_PATH,
  REGRAS_GERAIS_EMPRESTIMO,
  REGULAMENTO_EMPRESTIMO,
  REQUERIMENTOS,
  RESERVA_MATEMATICA,
  SAQUE_VISTA,
  SEGUNDA_VIA_BOLETO,
  SIMULADOR_ABSOLUTE_PATH,
  SIMULADOR_RESGATE_PARCIAL,
  SOLICITACAO_RESGATE_PARCIAL_FORMULARIO,
  TABELA_CONTRIBUICAO,
  TIRA_DUVIDAS,
  TRANSFORMACAO_BENEFICIO,
  TRANSPARENCIA,
  TROCA_DE_PERFIL_ABSOLUTE_PATH,
  VALOR_BENEFICIO,
} from '../../common/utils/paths';

const links = [
  {
    label: 'Página Inicial',
    to: HOME,
  },
  {
    label: 'Módulo de Benefícios',
    id: [
      'simular_beneficio',
      'contracheque',
      'simular_conversao_beneficio',
      'informe_rendimento',
      'memoria_calculo',
      'parcela_adicional',
      'alterar_recebimento',
      'reserva_matematica',
      'saque_vista',
      'transformacao_reserva',
      'cpa',
    ],
    type: 'grupo',
  },
  {
    label: 'Benefícios',
    to: BENEFICIOS,
    id: 'simular_beneficio',
    type: 'link',
  },
  /*
  {
    label: 'Calculadora de Exaurimento',
    to: CALCULADORA_EXAURIMENTO,
    id: 'transformacao_reserva',
  },
  */
  {
    label: 'Contracheque',
    to: CONTRACHEQUE,
    id: 'contracheque',
    type: 'link',
  },
  {
    label: 'Conversão de Benefícios',
    to: CONVERSAO_BENEFICIOS,
    id: 'simular_conversao_beneficio',
    type: 'link',
  },
  {
    label: 'Informe de rendimentos',
    to: INFORME_RENDIMENTOS,
    id: 'informe_rendimento',
    type: 'link',
  },
  {
    label: 'Memória cálculo de benefício',
    to: MEMORIA_CALCULO,
    id: 'memoria_calculo',
    type: 'link',
  },
  {
    label: 'Parcela adicional',
    to: PARCELA_ADICIONAL,
    id: 'parcela_adicional',
    type: 'link',
  },
  {
    label: 'Percentual Recebimento Renda',
    to: PERCENTUAL_RENDA_MENSAL_ABSOLUTE_PATH,
    id: 'alterar_recebimento',
    type: 'link',
  },
  {
    label: 'Reserva Matemática',
    to: RESERVA_MATEMATICA,
    id: 'reserva_matematica',
    type: 'link',
  },
  {
    label: 'Saque à vista',
    to: SAQUE_VISTA,
    id: 'saque_vista',
    type: 'link',
  },

  {
    label: 'Transformação de benefício',
    to: TRANSFORMACAO_BENEFICIO,
    id: 'transformacao_reserva',
    type: 'link',
  },

  {
    label: 'Valor benefício (CPA)',
    to: VALOR_BENEFICIO,
    id: 'cpa',
    type: 'link',
  },
  {
    label: 'Institutos',
    id: ['resgate_parcial'],
    type: 'grupo',
  },
  {
    label: 'Simulador do Resgate Parcial',
    to: SIMULADOR_RESGATE_PARCIAL,
    id: 'resgate_parcial',
    type: 'link',
  },
  {
    label: 'Solicitação do Resgate Parcial',
    to: SOLICITACAO_RESGATE_PARCIAL_FORMULARIO,
    id: 'resgate_parcial',
    type: 'link',
  },
  {
    label: 'Cadastro',
    type: 'grupo',
  },
  {
    label: 'Meus dados',
    to: MEUS_DADOS,
    type: 'link',
  },
  {
    label: 'Contribuição',
    id: [
      'tabela_contribuicao',
      'percentual_contribuicao',
      'segunda_via_boleto',
      'aporte',
    ],
    type: 'grupo',
  },
  {
    label: 'Calculadora de contribuição',
    to: TABELA_CONTRIBUICAO,
    id: 'tabela_contribuicao',
    type: 'link',
  },
  {
    label: 'Histórico Intencao Mudanca Percentual Contribuição',
    to: INTENCAO_MUDANCA_PC_ABSOLUTE_PATH,
    id: 'percentual_contribuicao',
    type: 'link',
  },
  {
    label: 'Histórico Mudanca Percentual Contribuição',
    to: MUDANCA_PC_ABSOLUTE_PATH,
    id: 'percentual_contribuicao',
    type: 'link',
  },
  {
    label: 'Segunda via de boleto',
    to: SEGUNDA_VIA_BOLETO,
    id: 'segunda_via_boleto',
    type: 'link',
  },
  {
    label: 'Solicitação de contribuição voluntária​',
    to: EMISSAO_BOLETO_VOLUNTARIO,
    id: 'aporte',
    type: 'link',
  },
  {
    label: 'Dúvidas',
    type: 'grupo',
  },
  {
    label: 'Fale conosco',
    to: CONTATO_EMPRESTIMO,
    type: 'link',
  },
  {
    label: 'Empréstimo',
    id: ['contratos_aberto', 'simular_emprestimo'],
    type: 'grupo',
  },
  {
    label: 'Calendário de empréstimos',
    to: CALENDARIO_EMPRESTIMO,
    type: 'link',
  },
  {
    label: 'Contratos em aberto',
    to: CONTRATOS_ABSOLUTE_PATH,
    id: 'contratos_aberto',
    type: 'link',
  },
  {
    label: 'Imposto de renda',
    to: IMPOSTO_DE_RENDA,
    type: 'link',
  },
  {
    label: 'Regras gerais',
    to: REGRAS_GERAIS_EMPRESTIMO,
    type: 'link',
  },
  {
    label: 'Regulamento',
    to: REGULAMENTO_EMPRESTIMO,
    type: 'link',
  },
  {
    label: 'Saiba mais sobre o empréstimo consciente',
    to: EMPRESTIMO_CONSCIENTE,
    type: 'link',
  },
  {
    label: 'Simular e contratar',
    to: SIMULADOR_ABSOLUTE_PATH,
    id: 'simular_emprestimo',
    type: 'link',
  },
  {
    label: 'Empréstimos: Tire suas dúvidas',
    to: TIRA_DUVIDAS,
    type: 'link',
  },
  {
    label: 'Extrato',
    id: ['extrato_conta_ativo', 'extrato_aposentadoria', 'extrato_cnpc'],
    type: 'grupo',
  },
  {
    label: 'Extrato de conta',
    to: EXTRADO_SALDO_CONTAS,
    id: 'extrato_conta_ativo',
    type: 'link',
  },
  {
    label: 'Extrato de conta de aposentadoria',
    to: EXTRADO_SALDO_CONTAS,
    id: 'extrato_aposentadoria',
    type: 'link',
  },
  {
    label: 'Extrato do Participante',
    to: EXTRATO_PARTICIPANTE,
    id: 'extrato_cnpc',
    type: 'link',
  },
  {
    label: 'Investimentos',
    id: ['historico_perfil', 'questionario_investidor'],
    type: 'grupo',
  },
  {
    label: 'Histórico de intenção de mudança de perfil',
    to: INTENCAO_MUDANCA_PERFIL_ABSOLUTE_PATH,
    id: 'historico_perfil',
    type: 'link',
  },
  {
    label: 'Histórico de mudança de perfil',
    to: MUDANCA_PERFIL_ABSOLUTE_PATH,
    id: 'historico_perfil',
    type: 'link',
  },
  {
    label: 'Perfil de investimento',
    to: TROCA_DE_PERFIL_ABSOLUTE_PATH,
    id: 'questionario_investidor',
    type: 'link',
  },
  {
    label: 'Questionário de perfil de investimento',
    to: QUESTIONARIO_ABSOLUTE_PATH,
    id: 'questionario_investidor',
    type: 'link',
  },
  {
    label: 'Personalização',
    type: 'grupo',
  },
  {
    label: 'Personalização',
    to: PERSONALIZACAO,
    type: 'link',
  },
  {
    label: 'Requerimentos',
    type: 'grupo',
  },
  {
    label: 'Requerimentos',
    to: REQUERIMENTOS,
    type: 'link',
  },
  {
    label: 'Transparência',
    type: 'grupo',
  },
  {
    label: 'Alterações Estatuárias',
    to: `${TRANSPARENCIA}/alteracoesEstatuarias`,
    type: 'link',
  },
  {
    label: 'Alterações Regulamentares',
    to: `${TRANSPARENCIA}/alteracoesRegulamentares`,
    type: 'link',
  },
  {
    label: 'Atas do Conselho Deliberativo',
    to: `${TRANSPARENCIA}/atasConselhoDeliberativo`,
    type: 'link',
  },
  {
    label: 'Atas do Conselho Fiscal',
    to: `${TRANSPARENCIA}/atasConselhoFiscal`,
    type: 'link',
  },
  {
    label: 'Comunicação sobre o plano',
    to: COMUNICACAO_PLANO,
    id: 'comunicacao_plano',
    type: 'link',
  },
  {
    label: 'Fornecedores',
    to: `${TRANSPARENCIA}/fornecedores`,
    type: 'link',
  },
  {
    label: 'Participações em Assembleias',
    to: `${TRANSPARENCIA}/participacoesAssembleias`,
    type: 'link',
  },
  // {
  //   label: 'Simular usuário',
  //   to: SIMULAR_USUARIO_PORTAL,
  //   type: 'link',
  // },
];

export const OutrasInformacoesPage = () => {
  const telasAtivas = useSelector((state) => state.telasDisponiveis);

  return (
    <>
      <Helmet>
        <title>Forluz - Mapa de Site</title>
      </Helmet>
      <h1 className="page-title fw-bold mb-32">Mapa de site</h1>

      <div className="card">
        <div className="card-body">
          {links.map((link) => {
            if (link.id && link.type !== 'grupo') {
              if (telasAtivas[link.id]) {
                return (
                  <Fragment key={link.to}>
                    <FLink to={link.to} icon className="mb-3">
                      {link.label}
                    </FLink>
                  </Fragment>
                );
              }

              return null;
            }

            if (link.type === 'grupo') {
              if (link.id) {
                let exibeGrupo = false;
                link.id.map((linkPermissionamento) => {
                  if (telasAtivas[linkPermissionamento]) {
                    exibeGrupo = true;
                  }
                  return null;
                });
                if (exibeGrupo)
                  return (
                    <Fragment key={link.to}>
                      <h3 className="text-muted fw-bold ts-20 mt-32 mb-3">
                        {link.label}
                      </h3>
                    </Fragment>
                  );
              } else {
                return (
                  <Fragment key={link.to}>
                    <h3 className="text-muted fw-bold ts-20 mt-32 mb-3">
                      {link.label}
                    </h3>
                  </Fragment>
                );
              }
            }

            // if (link.to === SIMULAR_USUARIO_PORTAL) {
            //   if (localStorage.getItem('nivelsessao') === '2') {
            //     return (
            //       <Fragment key={link.to}>
            //         <h3 className="text-muted fw-bold ts-20 mt-32 mb-3">
            //           Disponível apenas para uso interno
            //         </h3>

            //         <FLink to={link.to} icon className="mb-3">
            //           {link.label}
            //         </FLink>
            //       </Fragment>
            //     );
            //   }
            //   return null;
            // }

            return (
              <Fragment key={link.to}>
                <FLink to={link.to} icon className="mb-3">
                  {link.label}
                </FLink>
              </Fragment>
            );
          })}
        </div>
      </div>
    </>
  );
};
